/* @flow */
import { connect } from 'react-redux';
import { mountModal } from 'lib/modal';
import GroupQuickSwitcher from './GroupQuickSwitcher.jsx';
import GroupStore from 'groups/stores/GroupStore';
import KeyboardShortcuts from 'lib/KeyboardShortcuts';
import React from 'react';
import type { Status } from 'groups/reducers/groupQuickSwitcher';

type Props = {
  groupQuickSwitcherStatus: Status,
}

class GroupKeyboardListener extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress);
  }

  onKeyPress = (event: any) => {
    if (KeyboardShortcuts.isQuickSwitch(event)) {
      if (this.props.groupQuickSwitcherStatus !== 'open') {
        this.displayQuickSwitcher();
      }
      event.preventDefault();
    } else if (KeyboardShortcuts.isNextUnread(event)) {
      this.routeToNextUnreadGroup();
      event.preventDefault();
    }
  }

  displayQuickSwitcher = () => {
    mountModal(<GroupQuickSwitcher />, this);
  }

  routeToNextUnreadGroup = () => {
    const groups = GroupStore.getSubscribedGroups().models;

    for (const group of groups) {
      if (group.get('unread_messages') > 0) {
        this.context.router.push(`/classes/${group.getCode()}`);
        return;
      }
    }
  }

  render() {
    return null;
  }
}

function mapStateToProps(state: Object) {
  return {
    groupQuickSwitcherStatus: state.groupQuickSwitcher.status,
  };
}

export default connect(
  mapStateToProps,
)(GroupKeyboardListener);



// WEBPACK FOOTER //
// ./src/groups/components/GroupKeyboardListener.jsx